import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "relative rounded-md bg-white py-1.5 pr-1.5 pl-3 shadow-sm ring-1 ring-inset ring-gray-300 w-full group/filter-box" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "font-normal mb-1" }
const _hoisted_4 = { class: "text-sm flex items-center" }
const _hoisted_5 = { class: "mr-3 text-gray-400" }
const _hoisted_6 = { class: "max-w-[180px] overflow-hidden whitespace-nowrap text-ellipsis mr-1 text-gray-500" }
const _hoisted_7 = { class: "rounded-lg shadow-lg min-w-[220px] ring-1 bg-white ring-gray-300 text-sm px-1 py-2" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "px-5 py-1.5 hover:bg-gray-100 rounded-md cursor-pointer" }
const _hoisted_10 = ["onClick"]

import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import { XMarkIcon } from "@heroicons/vue/24/outline";
import VueDatePicker from "@vuepic/vue-datepicker";
import { startOfDay } from "date-fns";
import { format } from "date-fns";
import debounce from "lodash.debounce";
import { computed, Ref } from "vue";
import { useI18n } from "vue-i18n";
import { ReportDateFilter } from "@/types/reports/filters";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportDateFilterField',
  props: {
    filter: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t, locale } = useI18n();

const presetRanges: Ref<
  { label: string; value: Exclude<ReportDateFilter["type"], "date_range" | "total"> }[]
> = computed(() => [
  {
    label: t("time.last_day"),
    value: "last_day",
  },
  {
    label: t("time.last_week", 1),
    value: "last_week",
  },
  {
    label: t("time.last_calendar_week"),
    value: "last_calendar_week",
  },
  {
    label: t("time.last_week", 2),
    value: "last_2_weeks",
  },
  {
    label: t("time.last_month", 1),
    value: "last_month",
  },
  {
    label: t("time.last_month", 3),
    value: "last_3_months",
  },
  {
    label: t("time.last_month", 6),
    value: "last_6_months",
  },
  {
    label: t("time.last_month", 12),
    value: "last_12_months",
  },
]);

const timeRangeLabel = computed(() => {
  if (props.filter.type === "total") {
    return t("time.all_time");
  }
  if (props.filter.type === "date_range" && props.filter.start_date && props.filter.end_date) {
    return `${format(props.filter.start_date, "dd.MM.yyyy")} - ${format(
      props.filter.end_date,
      "dd.MM.yyyy",
    )}`;
  }
  return presetRanges.value.find((preset) => preset.value === props.filter.type)?.label;
});

const datePickerRange = computed(() => {
  const now = new Date();
  return [props.filter.start_date ?? now, props.filter.end_date ?? now];
});

const handleDateChange = (range: [Date, Date]) => {
  debouncedEmitChange({
    type: "date_range",
    start_date: startOfDay(range[0]),
    end_date: startOfDay(range[1]),
  });
};

const debouncedEmitChange = debounce((payload: ReportDateFilter) => {
  emit("change", payload);
}, 300);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("buttons.time_range")), 1),
      _createElementVNode("div", {
        class: "cursor-pointer p-1 invisible group-hover/filter-box:visible rounded-md hover:bg-red-200 active:bg-red-300 transition-colors duration-100",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(debouncedEmitChange)({ type: 'total', start_date: null, end_date: null })))
      }, [
        _createVNode(_unref(XMarkIcon), {
          class: "h-4 w-4 select-none",
          "aria-hidden": "true"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)("analytics.reports.is")), 1),
      _createVNode(_unref(Popover), { class: "relative flex flex-1" }, {
        default: _withCtx(() => [
          _createVNode(_unref(PopoverButton), { class: "outline-none flex flex-1" }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass([
              'flex flex-1 py-0.5 px-4 border rounded-full max-w-60 cursor-pointer',
              timeRangeLabel.value ? 'border-gray-300' : 'border-yellow-400',
            ])
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(timeRangeLabel.value), 1)
              ], 2)
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            "enter-active-class": "transition duration-200 ease-out",
            "enter-from-class": "translate-y-1 opacity-0",
            "enter-to-class": "translate-y-0 opacity-100",
            "leave-active-class": "transition duration-150 ease-in",
            "leave-from-class": "translate-y-0 opacity-100",
            "leave-to-class": "translate-y-1 opacity-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(PopoverPanel), { class: "absolute left-0 z-10 mt-7" }, {
                default: _withCtx(({ close }) => [
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(presetRanges.value, (preset) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: "px-5 py-1.5 hover:bg-gray-100 rounded-md cursor-pointer",
                        onClick: ($event: any) => {
                  _unref(debouncedEmitChange)({ type: preset.value, start_date: null, end_date: null });
                  close();
                },
                        key: preset.value
                      }, _toDisplayString(preset.label), 9, _hoisted_8))
                    }), 128)),
                    _createVNode(_unref(VueDatePicker), {
                      modelValue: datePickerRange.value,
                      columns: 4,
                      "enable-time-picker": false,
                      placeholder: `${_unref(t)('report.bulk_export.main_label')}`,
                      locale: _unref(locale),
                      format: "dd.MM.yyyy",
                      "auto-apply": "",
                      range: "",
                      "onUpdate:modelValue": ($event: any) => {
                  handleDateChange($event);
                  close();
                }
                    }, {
                      trigger: _withCtx(() => [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)("analytics.reports.absolute_date")), 1)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "placeholder", "locale", "onUpdate:modelValue"]),
                    _createElementVNode("p", {
                      class: "px-5 py-1.5 hover:bg-gray-100 rounded-md cursor-pointer",
                      onClick: ($event: any) => {
                  _unref(debouncedEmitChange)({ type: 'total', start_date: null, end_date: null });
                  close();
                }
                    }, _toDisplayString(_unref(t)("time.all_time")), 9, _hoisted_10)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})